import { jsx as _jsx } from "react/jsx-runtime";
import { TextField } from '@/core/ui/TextField';
import { floatPositiveNumberLowRestriction, integerNumberRegex, replaceEverythingExceptNumbersAndMinusRegex, wholePositiveAndNegativeNumberWithSingleMinusRegex, } from '@/core/utils/validation';
import { forwardRef } from 'react';
import { getUnitLabel } from './getUnitLabel';
/**
 * **IMPORTANT!** **Legacy** version. Use `NumericFieldV2` instead.
 *
 * // TODO: remove the component later when V2 version is used everywhere
 */
const NumericField = forwardRef(({ variant = 'whole', type, onChange, ...props }, ref) => {
    const adornment = type ? { endAdornment: getUnitLabel(type) } : {};
    return (_jsx(TextField, { ref: ref, ...adornment, ...props, onChange: (event) => {
            const value = event.target.value;
            if (value === '') {
                onChange(null);
                return;
            }
            switch (variant) {
                case 'whole': {
                    if (integerNumberRegex.test(value)) {
                        // -- @ts-expect-error ts could infer right type of `onChange` according to `variant` prop
                        onChange(Number(value));
                    }
                    break;
                }
                case 'wholeNegative': {
                    // Cut out all not allowed chars on `onPaste`. So paste can work and will not be blocked by following `.test` below.
                    const newValue = value.replace(replaceEverythingExceptNumbersAndMinusRegex, '');
                    if (wholePositiveAndNegativeNumberWithSingleMinusRegex.test(newValue)) {
                        // -- @ts-expect-error ts could infer right type of `onChange` according to `variant` prop
                        if (newValue === '-')
                            onChange(newValue);
                        // -- @ts-expect-error ts could infer right type of `onChange` according to `variant` prop
                        else
                            onChange(Number(newValue));
                    }
                    break;
                }
                case 'floatPositive': {
                    if (floatPositiveNumberLowRestriction.test(value)) {
                        // --@ts-expect-error ts could infer right type of `onChange` according to `variant` prop
                        onChange(value);
                    }
                    break;
                }
                default: {
                    throw new Error(`Unhandled NumericField variant case: ${variant}`);
                }
            }
        } }));
});
export { NumericField };
